/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClaimMainPageComponent} from './claim-main-page.component';
import {ClaimListComponent} from './claim-list/claim-list.component';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {PipesModule} from '../../shared/pipes/pipes.module';
import {StatusDotModule} from '../../shared/status-dot/status-dot.module';
import {NgbCollapseModule, NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {PaginationModule} from '../../shared/pagination/pagination.module';
import {InputAndCodeFilterModule} from '../../shared/filter/input-and-code-filter/input-and-code-filter.module';
import {RouterModule} from '@angular/router';
import {MaterialPositionTableModule} from '../shared/material-position-table/material-position-table.module';
import {CodeFilterModule} from '../../shared/filter/code-filter/code-filter.module';
import {DateFilterModule} from '../../shared/filter/date-filter/date-filter.module';

@NgModule({
    declarations: [
        ClaimMainPageComponent,
        ClaimListComponent
    ],
    imports: [
        CommonModule,
        TooltipModule,
        LoadingSpinnerModule,
        PipesModule,
        StatusDotModule,
        NgbDropdownModule,
        PaginationModule,
        InputAndCodeFilterModule,
        RouterModule,
        NgbCollapseModule,
        MaterialPositionTableModule,
        CodeFilterModule,
        DateFilterModule
    ],
    exports: [ClaimMainPageComponent]
})
export class ClaimMainPageModule {
}
